import { useMemo } from 'react'
import { Trash2 } from 'lucide-react'

import { useRoadbook } from '../../data/roadbookContext'
import { expenseSums } from '../../lib/expenseChart'
import { money } from '../../lib/format'
import { categories } from '../../lib/seed'
import { totalSpent, tripTotals } from '../../lib/trip'
import { fahrzeug } from '../../lib/vehicle'
import { ExpenseCharts } from './ExpenseCharts'
import { ExpenseForm } from './ExpenseForm'

export function BudgetView() {
  const { trip, diary, expenses, deleteExpense, darfSchreiben } = useRoadbook()
  const currency = trip.meta.currency
  // Die Kraftstoffkategorie heisst wie das, was dieses Fahrzeug tankt.
  const kraftstoff = fahrzeug(trip).fuel

  const totals = useMemo(() => tripTotals(trip, diary), [trip, diary])
  const spent = useMemo(() => totalSpent(expenses), [expenses])

  const byCategory = useMemo(() => expenseSums(expenses, kraftstoff), [expenses, kraftstoff])

  const proTag = totals.drivenCount > 0 ? spent / totals.drivenCount : 0

  return (
    <section className="seite">
      <div className="budgetzahlen">
        <div>
          <b>{money(spent, currency)}</b>
          <span>ausgegeben</span>
        </div>
        <div>
          <b>{money(totals.fuelCost, currency)}</b>
          <span>Kraftstoff geschätzt</span>
        </div>
        <div>
          <b>{money(proTag, currency)}</b>
          <span>pro gefahrenem Tag</span>
        </div>
      </div>

      {darfSchreiben && <ExpenseForm />}

      {byCategory.length > 0 && <ExpenseCharts data={byCategory} currency={currency} />}

      <ul className="ausgabenliste">
        {expenses.length === 0 && (
          <li className="leer">
            {darfSchreiben
              ? 'Noch nichts erfasst. Erste Ausgabe oben eintragen.'
              : 'Noch nichts erfasst.'}
          </li>
        )}
        {[...expenses].reverse().map((expense) => (
          <li key={expense.id}>
            <span
              className="punkt"
              style={{
                background: categories(kraftstoff).find((c) => c.key === expense.category)?.color,
              }}
              aria-hidden="true"
            />
            <b>{expense.category}</b>
            <span className="notiz">{expense.note}</span>
            <span className="betrag">{money(expense.amount, currency)}</span>
            {darfSchreiben && (
              <button
                type="button"
                className="weg kein-druck"
                onClick={() => deleteExpense(expense.id)}
                aria-label={`Ausgabe ${expense.category} ${money(expense.amount, currency)} löschen`}
              >
                <Trash2 size={13} />
              </button>
            )}
          </li>
        ))}
      </ul>
    </section>
  )
}
